import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const SyncBar = ({ summary }) => {
  const theme = useTheme();
  const t     = theme.custom;

  const lastSync = summary?.lastSyncAt
    ? new Date(summary.lastSyncAt).toLocaleTimeString("en-GB", {
        hour: "2-digit", minute: "2-digit",
      })
    : "—";

  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: "8px",
      padding: "8px 20px",
      background: t.surface2,
      borderBottom: `1px solid ${t.border}`,
    }}>
      {/* Live dot */}
      <Box sx={{
        width: "7px", height: "7px", borderRadius: "50%",
        background: "#4ade80",
        boxShadow: "0 0 5px rgba(74,222,128,0.65)",
        flexShrink: 0,
        animation: "syncPulse 2.2s ease-in-out infinite",
        "@keyframes syncPulse": {
          "0%, 100%": { opacity: 1,   transform: "scale(1)"    },
          "50%":      { opacity: 0.5, transform: "scale(0.85)" },
        },
      }} />

      <Typography sx={{
        fontFamily: "'Inter', sans-serif",
        fontSize: "11px", color: t.text2, fontWeight: 300,
      }}>
        Zoho sync active · {summary?.totalAssociates ?? "—"} associates ·{" "}
        <Box component="span" sx={{ color: t.accent, fontWeight: 600 }}>
          {summary?.newPendingAllocation ?? 0} newly added
        </Box>
        {" "}pending allocation
      </Typography>

      <Typography sx={{
        fontFamily: "'DM Mono', monospace",
        fontSize: "10px", color: t.text3,
        ml: "auto",
      }}>
        Last sync: Today {lastSync}
      </Typography>
    </Box>
  );
};

export default SyncBar;